// Phoenix is loaded via CDN and attached to window at runtime.
// Do NOT destructure at module level — window is unavailable during webpack build.
function getPhoenix() {
  if (typeof window !== "undefined" && window.Phoenix) return window.Phoenix;
  throw new Error("[Socket] window.Phoenix is not loaded. Ensure phoenix.js CDN is included before the app bundle.");
}
import { api_end_point } from "@/services/api";

let socket = null;
let currentUser = null; // store logged-in user info

// Login API call + connect socket
export async function loginAndConnect(email, password, prefix) {
  try {
    const res = await fetch(`${api_end_point}/users/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password, prefix })
    });
    const data = await res.json();

    if (data.token) {
      localStorage.setItem("TOKEN", data.token);
      currentUser = data.user;
      const socketInstance = connectSocket(data.token, data.user);
      return { socket: socketInstance, user: data.user };
    }

    console.error("Login failed", data);
    return null;
  } catch (err) {
    console.error("Login error", err);
    return null;
  }
}

// Connect socket with optional token and user info
export function connectSocket(token = null, user = null, entity_id = null) {
  if (!token) token = localStorage.getItem("TOKEN");
  if (!token) {
    console.error("[Socket] Token missing!");
    return null;
  }

  if (socket && socket.isConnected()) return socket;

  const wsUrl = api_end_point.replace(/^http/, "ws") + "/socket";
  // console.log(wsUrl," wsUrl");

  let domain = "cmp_"+localStorage.getItem("domain");
  if (!entity_id) entity_id = Number(localStorage.getItem("ENTITY_ID"));
  console.log(user,"user.....")
  const { Socket } = getPhoenix();
  socket = new Socket(wsUrl, {
    params: {
      token,
      prefix: domain,
      user_id: user || currentUser?.id,
      entity_id: entity_id
    }
  });

  // console.log(socket," socket");


  socket.onOpen(() => console.log("[Socket] Connected"));
  socket.onError(() => console.error("[Socket] Connection Error"));
  socket.onClose(() => console.warn("[Socket] Disconnected"));

  socket.connect();
  return socket;
}

// Join a chat room
export function joinRoom(roomId,otherUserId, handlers = {}) {
  if (!socket) throw new Error("[Socket] Must connect first");
  //  console.log(localStorage.getItem("VBJ_TOKEN")," token in joinRoom");
  // Decode user_id from token if currentUser not set
  if (!currentUser) {
    const token = localStorage.getItem("TOKEN");
    try {
      
      const payload = JSON.parse(atob(token.split(".")[1]));
      const user_id = payload.sub ? payload.sub.split("@")[0] : null;
      currentUser = { id: user_id };
    } catch (e) {
      console.warn("[Socket] Could not decode user_id from token", e);
    }
  }
  console.log(localStorage.getItem("USER_ID"),"user_id")
  const channel = socket.channel(`chat_room:${roomId}`, {
    user_id:localStorage.getItem("USER_ID"),
    prefix: "cmp_"+ localStorage.getItem("domain"),
  });

  // console.log(channel," channel from socket.js");

  const { Presence } = getPhoenix();
  const presence = new Presence(channel);

  // let prefix = "cmp_"+ localStorage.getItem("domain");

  channel.join()
    .receive("ok", resp => {
      
      handlers.onJoin?.(resp);
      console.log("[Channel]" ,`Joined room:${roomId}`, resp);
    })
    .receive("error", resp => {
      // console.error("[Channel]" ,`Failed to join room:${roomId}`, resp);
      handlers.onError?.(resp);
    });
  channel.on("message:new", payload => {
    // ✅ Debug: log every received message
    console.log("📩 [Channel] Received message payload:", payload);

    // Call user-defined handler if exists
    handlers.onMessage?.(payload);
  });
  // console.log("channel before on", channel);
  // channel.on("message:new", payload => handlers.onMessage?.(payload));
  channel.on("typing", payload => handlers.onTyping?.(payload));

    // console.log("channel after join", channel);
  // presence.onSync(() => {
  //   const list = presence.list((id, { metas }) => ({
  //     user_id: metas[0].user_id,
  //     name: metas[0].name
  //   }));
  //   handlers.onPresence?.(list);
  // });

  //(maheshwar) presence.onSync(() => {
  //   presence.onSync(() => {
  //   const list = presence.list((id, { metas }) => {
  //     const meta = metas?.[0]; // Safe access
  //     return {
  //       user_id: meta?.user_id || null,
  //       name: meta?.name || "Unknown"
  //     };
  //   });
  //   handlers.onPresence?.(list);
  // });
  presence.onSync(() => {
    const list = presence.list((id, { metas }) => ({
      user_id: parseInt(id.replace(/^user:/, "")), 
      name: metas[0]?.name || "Unknown",
      online: metas.length > 0
    }));
    
    // Only care about the selected conversation user
    const otherUserStatus = list.find(u => u.user_id == otherUserId) || { online: false };
    console.log("Presence list updated:", otherUserStatus);
    handlers.onPresence?.(otherUserStatus);
  });
  channel.on("message:delivered", payload => {
    console.log("✅ Delivered update", payload);
    handlers.onDelivered?.(payload);
  });

  channel.on("message:read", payload => {
    console.log("👁 Read update", payload);
    handlers.onRead?.(payload);
  });


  return { channel, presence };
}

// Send message to a room
// export function sendMessage(channel, content, file = null) {
//   if (!currentUser) {
//     console.error("[Socket] No currentUser set!");
//     return;
//   }

//   const payload = {
//     content,
//     chatroom_id: channel.topic.split(":")[1],
//     sender_id: currentUser.id,
//     sender_name: currentUser.name,
//     file: file || null
//   };

//   // Push to server
//   channel.push("message:new", payload)
//     .receive("ok", resp => console.log("Message sent", resp))
//     .receive("error", err => console.error("Message send failed", err));
// }
export function sendMessage(channel, payload) {
  if (!currentUser) {
    console.error("[Socket] No currentUser set!");
    return;
  }
  console.log("📤 Sending message...", payload);

  channel.push("message:new", payload)
    .receive("ok", resp => {
      console.log("✅ Message sent successfully:", resp);
    })
    .receive("error", err => {
      console.error("❌ Message send failed:", err);
      console.error("Payload that failed:", payload);
    })
    .receive("timeout", () => {
      console.error("⏱️ Message send timeout - no response from server");
    });
}

// Leave a room
export function leaveRoom(channel) {
  if (channel) channel.leave();
}



// Disconnect socket completely
export function disconnectSocket() {
  if (channel) {
    channel.leave();          // Leave the channel first
    channel = null;
  }
  
  if (socket) {
    socket.disconnect();      // Disconnect the socket
    socket = null;
    currentUser = null;
    console.log("✅ Socket disconnected");
  }
}